module.exports = __webpack_public_path__ + "static/school_processor2@2x-da7d27f9b2de42c09573cc681daa0a99.png";